import React from "react";

/**
 * Noyaa Pharma brand mark — capsule + wordmark.
 * Sizes: sm (nav), md (footer), lg (splash).
 */
export default function Logo({ size = "sm", theme = "light", showWord = true, className = "" }) {
  const dims = { sm: 36, md: 44, lg: 64 }[size] || 36;
  const wordText = { sm: "text-lg", md: "text-xl", lg: "text-3xl" }[size] || "text-lg";
  const wordColor = theme === "dark" ? "text-white" : "text-slate-900";
  const subColor = theme === "dark" ? "text-emerald-400" : "text-emerald-600";

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg
        width={dims}
        height={dims}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="blzCapA" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#0F172A" />
            <stop offset="1" stopColor="#1E293B" />
          </linearGradient>
          <linearGradient id="blzCapB" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#10B981" />
            <stop offset="1" stopColor="#059669" />
          </linearGradient>
        </defs>
        {/* Capsule tilted -45° */}
        <g transform="rotate(-45 24 24)">
          <rect x="6" y="18" width="18" height="12" rx="6" fill="url(#blzCapA)" />
          <rect x="24" y="18" width="18" height="12" rx="6" fill="url(#blzCapB)" />
          {/* subtle highlight */}
          <rect x="8" y="19.5" width="14" height="2" rx="1" fill="#334155" opacity="0.6" />
          <rect x="26" y="19.5" width="14" height="2" rx="1" fill="#34D399" opacity="0.55" />
          {/* seam */}
          <line x1="24" y1="18" x2="24" y2="30" stroke={theme === "dark" ? "#0f172a" : "#F8FAFC"} strokeWidth="1" />
        </g>
      </svg>
      {showWord && (
        <div className="leading-none">
          <div className={`font-display font-extrabold tracking-tight ${wordText} ${wordColor}`}>
            Noyaa<span className={subColor}>.</span>
          </div>
          {size !== "sm" && (
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-1">Pharma</div>
          )}
        </div>
      )}
    </div>
  );
}
